import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import React from "react";
import Accordion from "react-bootstrap/Accordion";
var TrendingSearchBlock = function (props) {
    var device = DeviceContext();
    return (React.createElement("div", { className: "Trending-search-block pdt-20 ".concat((device === null || device === void 0 ? void 0 : device.isDesktop) ? "" : "pdlr-15") },
        React.createElement(Accordion, { defaultActiveKey: "0", flush: true },
            React.createElement(Accordion.Item, { eventKey: "0" },
                React.createElement(Accordion.Header, null, "Trending"),
                React.createElement(Accordion.Body, null, props.content)))));
};
export default TrendingSearchBlock;
